import React from 'react'
import { withRouter } from "react-router-dom"
import AuthService from '../../services/auth/AuthService'
import { Nav } from 'react-bootstrap'
import './UsersNavLink.css'

const UsersNavLink = (props) => {

  const isLoggedIn = AuthService.isLoggedIn()

  const onClick = (eventKey: any, event: SyntheticEvent) => {
    props.history.push('/users')
  }

  return (
    isLoggedIn ? <Nav.Link className="users-link" onSelect={onClick} eventKey="/users">Users</Nav.Link> : ''
  )
}

export default withRouter(UsersNavLink)
